// extracted by mini-css-extract-plugin
export default {"chart":"chart_chart__kJFOI"};